// extracted by mini-css-extract-plugin
export default {"popoverAnchor":"styles_popover-anchor__HOf5M"};